import React from "react";

function NoResultsFound({ message }) {
  return <div>{message}</div>;
}
export default NoResultsFound;
